import React, { useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { TextField, Button, Grid, Typography } from "@mui/material";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom"; // Use navigate for redirection
import MDBox from "components/MDBox";
import { getGameDetails } from "store/slice/gamesSlice";
import { deleteGame } from "store/slice/gamesSlice";
import { updateGameDetails } from "store/slice/gamesSlice";
import { gameActions } from "store/slice/gamesSlice";

const validationSchema = Yup.object({
  name: Yup.string().max(255, "Name must be 255 characters or less").required("Name is required"),
});

function GamesEdit() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const store = useSelector((store) => store.games);
  const { gameId } = useParams();

  useEffect(() => {
    if (gameId) {
      dispatch(getGameDetails(gameId));
    }
  }, [gameId, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(gameActions.reset())
    }
  }, [])

  const details = store.dealerDetails;
  const error = store.error; 
  const success = store.success;

  useEffect(() => {
    if (success?.status && gameId == 'new') {
      navigate(`/games/${details.id}`);
    }
  }, [success?.status])

  const initialValues = {
    name: details?.name || "",
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);
    await dispatch(updateGameDetails({ gameId, updatedData: values }));
    setSubmitting(false);
  };

  const handleDelete = async () => {
    const confirmDelete = window.confirm("Are you sure you want to delete this game?");
    if (confirmDelete) {
        await dispatch(deleteGame(gameId));
        navigate("/games"); 
    }
  };

  return (
    <DashboardLayout>
      <Typography variant="h4" gutterBottom>
        Edit Dealer Details
      </Typography>
      
      <MDBox mb={5}>
        {success.status || error.status ? (
          <div
            style={{
              color: success.status ? "green" : "red",
              padding: "10px",
              backgroundColor: success.status ? "#d4edda" : "#f8d7da",
              borderRadius: "5px",
              border: `1px solid ${success.status ? "#c3e6cb" : "#f5c6cb"}`,
              marginBottom: "10px",
            }}
          >
            {success.status
              ? "Game details updated successfully!"
              : "Failed to update dealer details. Please try again."}
          </div>
        ): ""}
      </MDBox>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ values, handleChange, handleBlur, touched, errors, isSubmitting }) => (
          <Form>
            <Grid container spacing={3}>

              <Grid item size={{ xs: 12, sm: 12 }}>
                <TextField
                  fullWidth
                  label="Name"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.name && Boolean(errors.name)}
                  helperText={touched.name && errors.name}
                  variant="outlined"
                />
              </Grid>

              <Grid item size={{ xs: 12 }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving..." : "Save Changes"}
                </Button>

                {/* Delete Button */}
                {gameId !== 'new'? <Button
                  variant="text"
                  color="error"
                  style={{ marginLeft: "10px" }}
                  onClick={handleDelete}
                >
                  Delete Game
                </Button>: ''}
                
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </DashboardLayout>
  );
}

export default GamesEdit;
